// extracted by mini-css-extract-plugin
export var wrapper = "FirstQuestion-module--wrapper--VIWDh";
export var ChekboxContainer = "FirstQuestion-module--ChekboxContainer--5MHqb";
export var content = "FirstQuestion-module--content--nBN7Z";
export var headline = "FirstQuestion-module--headline--lZBze";
export var chekboxAllStyle = "FirstQuestion-module--chekboxAllStyle--ercJt";
export var chekbox1 = "FirstQuestion-module--chekbox1--W1nh+";
export var chekbox2 = "FirstQuestion-module--chekbox2--rF0tY";
export var icon = "FirstQuestion-module--icon--LpKhu";
export var subtitle = "FirstQuestion-module--subtitle--A8n9T";